import type { GigRequestStatus } from "../../../types/gigTypes";

export type RequestViewFilter = "ACTIVE" | "AWAITING_CONFIRMATION" | "PAST" | "ALL";

export const ACTIVE_REQUEST_STATUSES: GigRequestStatus[] = [
  "GUARDIAN_PENDING",
  "POSTER_PENDING",
  "POSTER_SELECTED_PENDING_CREW",
  "PAYOUT_SETUP_PENDING",
  "FUNDING_PENDING",
];

export const PAST_REQUEST_STATUSES: GigRequestStatus[] = [
  "FILLED_BY_OTHER_TEEN",
  "GUARDIAN_REJECTED",
  "POSTER_REJECTED",
  "EXPIRED",
  "WITHDRAWN",
];

export const WITHDRAWABLE_STATUSES: GigRequestStatus[] = [
  "GUARDIAN_PENDING",
  "POSTER_PENDING",
  "POSTER_SELECTED_PENDING_CREW",
  "PAYOUT_SETUP_PENDING",
  "FUNDING_PENDING",
];

export const REQUEST_VIEW_OPTIONS: Array<{ label: string; value: RequestViewFilter; description: string }> = [
  {
    label: "Active Gigs Applied For",
    value: "ACTIVE",
    description: "Only show gigs you applied for that are still waiting on a decision.",
  },
  {
    label: "Gigs Awaiting Your Confirmation",
    value: "AWAITING_CONFIRMATION",
    description: "Only show gigs where the poster suggested the latest time and it is your turn to confirm it or send back a new one.",
  },
  {
    label: "Past Gigs Applied For",
    value: "PAST",
    description: "Show withdrawn, declined, and filled-by-another-teen gigs you applied for.",
  },
  {
    label: "All Gigs Applied For",
    value: "ALL",
    description: "Show the full history of gigs you applied for in one list.",
  },
];
